/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, Input } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { GenericModalComponent } from "../../../shared/components/generic-modal/generic-modal.component";
import { UserInfo } from "../../../shared/types/user-info";
import { Company } from "../companies/company.type";
import { CompanyAttachmentTableService } from "./company-attachment-table.service";
import { CompanyAttachmentService } from "./company-attachment.service";
import { CompanyAttachment } from "./company-attachment.type";
import { CreateCompanyAttachmentService } from "./create-company-attachment/create-company-attachment.service";

@Component({
  selector: "app-company-attachments-list",
  templateUrl: "./company-attachment.component.html",
  styleUrls: ["./company-attachment.component.scss"],
  providers: [CreateCompanyAttachmentService],
})
export class CompanyAttachmentComponent {
  @Input() company: Company;

  dialogRef: MatDialogRef<GenericModalComponent>;
  currentUser: UserInfo;
  companyAttachmentsTableConfig: DataTable<CompanyAttachment>;

  constructor(
    public dialog: MatDialog,
    public companyAttachmentService: CompanyAttachmentService,
    private authenticationService: AuthenticationService,
    public companyAttachmentTableService: CompanyAttachmentTableService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
    this.companyAttachmentsTableConfig = this.companyAttachmentTableService.getCompanyAttachmentsTableConfig({
      actionColumn: { hidden: true },
    });
  }
}
